import { useRef, useLayoutEffect } from 'react'

const isBrowser = typeof window !== `undefined`

/**
 * https://dev.to/n8tb1t/tracking-scroll-position-with-react-hooks-3bbj
 * 
 * Minimizes renders while checking scroll direction.
 * 
 * 
 * @param {Object} param0 
 * @returns 
 */
function getScrollPosition({ element, useWindow }) {
  if (!isBrowser) return { x: 0, y: 0 }

  const target = element ? element.current : document.body
  const position = target.getBoundingClientRect()

  return useWindow
    ? { x: window.scrollX, y: window.scrollY }
    : { x: position.left, y: position.top }
}

/**
 * 
 * effect: callback to be preformed. Will supply an object with {prevPos: position.current, currPos}
 * deps: State supplied to trigger callback
 * element: Element to reference. If not supplied will use document.body
 * useWindow: 
 * useWindow: true to use window.scroll, false for target.getBoundingClientRect
 * 
 * @param {Function} effect
 * @param {Array} deps 
 * @param {Ref} element 
 * @param {boolean} useWindow 
 * @param {*} wait 
 */
export function useScrollPosition(effect, deps, element, useWindow, wait) {
  const position = useRef(getScrollPosition({ useWindow }))

  let throttleTimeout = null

  const callBack = () => {
    const curr = getScrollPosition({ element, useWindow })
    effect({ prev: position.current, curr })
    position.current = curr
    throttleTimeout = null
  }

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait)
        }
      } else {
        callBack()
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, deps)
}